import { IComponentOptions } from "angular";
import { ProjectDetailController } from "./controller";

export const vsName = "projectDetailComponent";

export const projectDetailComponentOptions: IComponentOptions = {
  controller: ProjectDetailController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    project: "<",
  },
};
